<template>
    <v-navigation-drawer v-model="drawer" absolute app temporary>
        <v-list-item>
            <v-list-item-avatar>
                <v-img src="../../assets/default-avatar.jpg"
                       alt="Profile image"/>
            </v-list-item-avatar>

            <v-list-item-content>
                <v-list-item-title>{{ $store.getters.userName }}</v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
                <v-btn icon @click="goToSettings">
                    <v-icon>mdi-settings</v-icon>
                </v-btn>
            </v-list-item-action>
        </v-list-item>

        <v-divider/>

        <v-list dense>
            <v-list-item link to="/">
                <v-list-item-icon>
                    <v-icon>mdi-home-outline</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Home</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/characters">
                <v-list-item-icon>
                    <v-icon>mdi-account-multiple</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Characters</v-list-item-title>
                </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/character_classes" v-if="$store.getters.canModerator">
                <v-list-item-icon>
                    <v-icon>mdi-shield</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Classes</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
            <v-divider class="mt-6 mb-2"/>
            <v-list-item link @click="signOut">
                <v-list-item-icon>
                    <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>

                <v-list-item-content>
                    <v-list-item-title>Sign out</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </v-navigation-drawer>
</template>

<script>
  import AuthenticationService from "../../services/AuthenticationService";

  export default {
    data: () => ({
      drawer: null
    }),

    beforeMount() {
      AuthenticationService.viewUser(this.$store.state.user.id)
        .then(response => {
          this.$store.dispatch("setUser", response.data.data);
        });
    },

    methods: {
      async signOut() {
        this.drawer = false;
        await AuthenticationService.logout()
          .then(() => {
            this.emptyStore();
            this.$router.push({name: 'auth'})
          })
          .catch(() => {
            this.emptyStore();
          });
      },

      emptyStore() {
        this.$store.dispatch("clearUser");
        if (this.$route.name !== "home") {
          this.$router.push({
            name: "home"
          });
        }
      },

      goToSettings() {
        this.$router.push({name: "profile"});
      },

      toggleDrawer() {
        this.drawer = !this.drawer;
      }
    }
  };
</script>
